import { CoreType, LUISExample, NLPComparisonJobState, NLPComparisonRequest, NLPModelCache } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

export class NLPAPI {
  static async getCacheByCoreType(core: CoreType): Promise<NLPModelCache[]> {
    return APIService.Server.get<NLPModelCache[]>(`/nlp/caches/${core}`);
  }
  public async getCacheByAppId(appId: string, version: string, core: CoreType): Promise<NLPModelCache> {
    return APIService.Server.get<NLPModelCache>(`/nlp/cache`, { appId, version, core });
  }
  static async refreshCache(cacheId: string): Promise<boolean> {
    return APIService.Server.get<boolean>(`/nlp/cache/${cacheId}/refresh`);
  }
  static async getCLUProjects(): Promise<any[]> {
    return APIService.Server.get<any[]>(`/nlp/clu/projects`);
  }
  static async getCLUDeployments(projectName: string): Promise<any[]> {
    return APIService.Server.get<any[]>(`/nlp/clu/projects/${projectName}/deployments`);
  }
  static async getCLUTrainedModels(projectName: string): Promise<any[]> {
    return APIService.Server.get<any[]>(`/nlp/clu/projects/${projectName}/models`);
  }
  static async createCLUDeployment(projectName: string, deploymentName: string, trainedModelLabel: string): Promise<boolean> {
    return APIService.Server.post<boolean>(`/nlp/clu/projects/${projectName}/deployments/${deploymentName}`, { trainedModelLabel });
  }
  static async trainCLUModel(projectName: string, modelLabel: string, trainingMode: "standard" | "advanced"): Promise<boolean> {
    return APIService.Server.post<boolean>(`/nlp/clu/projects/${projectName}/train`, { modelLabel, trainingMode });
  }
  static async updateCacheConfig(cacheId: string, appId: string, version: string): Promise<boolean> {
    return APIService.Server.patch<boolean>(`/nlp/cache/${cacheId}`, { appId, version });
  }
  static async getLUISUtterances(appId: string, version: string): Promise<LUISExample[]> {
    return APIService.Server.get<LUISExample[]>(`/nlp/luis/${appId}/versions/${version}/utterances`);
  }
  static async startComparison(body: NLPComparisonRequest): Promise<{ jobId: string }> {
    return APIService.Server.post<{ jobId: string }>(`/nlp/comparison/start`, body);
  }
  static async getComparisonStatus(jobId: string): Promise<NLPComparisonJobState> {
    return APIService.Server.get<NLPComparisonJobState>(`/nlp/comparison/${jobId}`);
  }
}
